export const PRIVACY_TITLE: string = 'Privacy';
export const ELECTRONIC_COMMUNICATIONS_TITLE: string =
  'Electronic communications';
export const COPYRIGHT_TITLE: string = 'Copyright';
export const TRADEMARKS_TITLE: string = 'Trademarks';
export const LICENSE_AND_SITE_ACCESS_TITLE: string = 'License and site access';
export const FORWARD_LOOKING_STATEMENTS_TITLE: string =
  'Forward-looking statements';
export const DISCLAIMER_OF_WARRANIES_AND_LIMITATION_OF_LIABLITY_TITLE: string =
  'Disclaimer of warranies and limitation of liablity';
export const DESKTOP_WIDTH = 768;
export const MOBILE_WIDTH = DESKTOP_WIDTH + 1;
